import { RiGovernmentLine } from "@remixicon/react";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@workspace/ui/components/select";
import { cn } from "@/lib/utils";

interface Stage {
	id: string;
	name: string;
	position?: number;
}

interface StageFilterProps {
	value: string;
	onValueChange: (value: string) => void;
	stages: Stage[];
	className?: string;
}

export const StageFilter = function StageFilterComponent({
	value,
	onValueChange,
	stages,
	className,
}: StageFilterProps) {
	// Sort stages by position if available, otherwise by name
	const sortedStages = [...stages].sort((a, b) => {
		// Handle null/undefined positions - put them at the end
		if (a.position == null && b.position == null)
			return a.name.localeCompare(b.name);
		if (a.position == null) return 1;
		if (b.position == null) return -1;
		// Normal numeric sorting for non-null positions
		return a.position - b.position;
	});

	return (
		<Select value={value} onValueChange={onValueChange}>
			<SelectTrigger
				className={cn(
					"hover:bg-accent hover:text-accent-foreground active:scale-[0.99]",
					className,
				)}
			>
				<div className="flex items-center gap-2">
					<RiGovernmentLine className="h-4 w-4 text-muted-foreground" />
					<SelectValue placeholder="Filter by stage..." />
				</div>
			</SelectTrigger>
			<SelectContent>
				<SelectItem value="all">All Stages</SelectItem>
				{sortedStages.map((stage) => (
					<SelectItem key={stage.id} value={stage.id}>
						{stage.name}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
};
